module.exports = __webpack_public_path__ + "static/media/at.96945437.svg";